import { mapState } from 'vuex'
const controlLogMixin = {
  props: {
    PCTRLLOG: {
      //親のgetComponentTags
      type: Function,
      require: false
    },
  },
  computed: {
    ...mapState('auth', ['controlLogViewID']),
    CTRLLOG () {
      //エイリアス
      return this._getComponentTags
    }
  },
  mounted () {
    const componentTag = this.$options._componentTag
    if (!componentTag && !this.COMPONENT_NAME) {
      console.error(
        'The root component on the current route ' + this.$route.fullPath
        + ' (configured in Vue.router) does not have the "COMPONENT_NAME" property.\n'
        + 'Prease set "data () {return {COMPONENT_NAME: ____}}".')
    }
  },
  methods : {
    _getComponentTags(raiseError) {
      if (raiseError) {
        if (!this.PCTRLLOG) {
          const componentTag = this.$options._componentTag
          if (componentTag) {
            console.error('The control-log-chain is broken at <' + componentTag + '>.\n'
              + "The parent component's control-log-method is not bound to <" + componentTag + ">.\n"
              + 'Please bind using :PCTRLLOG="CTRLLOG".')
          }
          else {
            console.warn('There is nothing wrong with the control log chain.')
          }
        }
        else this.PCTRLLOG(true)
      }
      else {
        const componentTag = this.$options._componentTag
        if (!componentTag) {
          return [(this.COMPONENT_NAME || "NoNameComponent")]
        }
        else if (!this.PCTRLLOG) return null
        else {
          const tagHierarchy = this.PCTRLLOG(false)
          if (tagHierarchy) return tagHierarchy.concat([componentTag])
          else null
        }
      }
    },
    // 同期処理で呼び出すこと
    // optionsは付加情報のObject キーがそのまま詳細画面やCSVのカラム名に反映される
    sendControlLog(caption, desc, options={}) {
      const tagHierarchy = this._getComponentTags(false)
      if (tagHierarchy) {
        return this.$store.dispatch('auth/sendControlLog', {
          caption: caption,
          description: desc,
          url: this.$route.fullPath,
          vue_component: tagHierarchy.join(','),
          user_agent: window.navigator.userAgent,
          options: options,
        })
      }
      else return new Promise((resolve, reject) => {resolve()})
    },
    checkControlLogChain() {
      this._getComponentTags(true)
    },
    sendControlLogRelatedChatBot(caption, desc, chatbot) {
      return this.sendControlLog(caption, desc, {'ロボ': {'名前': chatbot.name, 'ID': chatbot.bot_id}})
    },
    sendControlLogRelatedUsage(caption, desc) {
      return this.$store.dispatch('auth/sendControlLog', {
        caption: caption,
        description: desc,
        url: this.$route.fullPath,
        vue_component: "Other",
        user_agent: window.navigator.userAgent,
        options: {viewID: this.controlLogViewID},
      })
    }
  }
}

export default controlLogMixin


// WEBPACK FOOTER //
// ./src/mixins/controlLogMixin.js